import React from "react";
import { connect } from "react-redux";
import type { AnyAction } from "redux";
import { RandomDisplay } from "./RandomDisplay";
import { appMetadataRandom, chooseRandomStudent, displayStudent, RandomSlice } from "src/pods/random";
import { displayClose } from "src/pods/realtime";
import { shareOverWire } from "src/pods/realtime/index";
import { Student } from "src/pods/students";
import PresentationPage from "src/shared/components/PresentationPage";

type RandomDisplayContainerProps = {
  // from random pod
  student: Student;
  students: Student[];
  previouslyChosenStudents: Student[];
  shareOverWire: (action: AnyAction) => void;
  isRestart?: boolean; // what is this being used for?
  displayClose: () => void;
};

type ConnectedProps = {
  dispatch: (action: AnyAction) => void;
};

const mapDispatchToProps = { displayClose, shareOverWire };
const mapStateToProps = (state: RandomSlice) => ({ ...state.random });

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class Container extends React.Component<Partial<RandomDisplayContainerProps & ConnectedProps>> {
  render() {
    return (
      <PresentationPage {...appMetadataRandom()} onRequestHide={this.props.displayClose}>
        <RandomDisplay
          fullscreen={true}
          displayRandomStudent={this.displayRandomStudent}
          student={this.props.student}
          students={this.props.students}
          isRestart={this.props.isRestart}
        />
      </PresentationPage>
    );
  }

  displayRandomStudent = () => {
    const chosenStudent = chooseRandomStudent(this.props.students, this.props.previouslyChosenStudents);
    const action: AnyAction = displayStudent(this.props.students, chosenStudent);
    this.props.shareOverWire?.(action);
  };
}
const RandomDisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Container);
export { RandomDisplayContainer };
